module.exports = __webpack_public_path__ + "img/client2.861a4204.jpg";